'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgNavMcp = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#88827E", d: "M11.21 2.895a3.477 3.477 0 0 1 4.787.124l.122.129c.715.79 1.001 1.83.86 2.82a3.471 3.471 0 0 1 2.952.984l.041.04a3.476 3.476 0 0 1 .123 4.787l-.123.13-7.115 7.115a.232.232 0 0 0 0 .328l1.461 1.46.047.054a.695.695 0 0 1-.978.978l-.052-.048-1.461-1.46a1.623 1.623 0 0 1 0-2.295l7.114-7.115.143-.159a2.086 2.086 0 0 0 0-2.633l-.142-.159-.041-.04-.159-.143a2.087 2.087 0 0 0-2.633 0l-.16.142-5.94 5.942a.696.696 0 0 1-.984-.983l5.941-5.941.143-.159a2.087 2.087 0 0 0 0-2.633L15.013 4a2.086 2.086 0 0 0-2.791-.142L12.063 4l-7.867 7.867a.696.696 0 0 1-.983-.983l7.867-7.866.13-.124Z" }),
  React__namespace.createElement("path", { fill: "#88827E", d: "M13.1 4.937a.695.695 0 0 1 .93 1.031L8.21 11.787a2.087 2.087 0 0 0 0 2.95l.159.143c.82.668 2.028.62 2.792-.143l5.818-5.82a.696.696 0 0 1 .984.984l-5.819 5.819a3.478 3.478 0 0 1-4.787.123l-.13-.123a3.477 3.477 0 0 1 0-4.917l5.819-5.818.053-.048Z" })
);

module.exports = SvgNavMcp;
//# sourceMappingURL=NavMcp.cjs.js.map
